module.exports = __webpack_public_path__ + "static/media/landing.b33a5695.png";